/**
 * Deaktiviert einen Widget-Link (ausgegraut, nicht klickbar) und hängt per
 * showWidgetLinkInfo einen Info-Hinweis an.
 *
 * Aufgerufen von ITCs BudgetBillingPlanWidget.js, solange ein vorheriger
 * Prozess noch läuft. Übernommen aus ITCs poco.ivu.js (2.7.14) — diese Datei
 * bindet unser Layout nicht ein; ITCs eigenes ivu.min.js enthielt die Funktion.
 * Muss in config.js nach showWidgetLinkInfo.js stehen, weil sie dessen
 * Implementierung beim Laden übernimmt.
 */
(function ($) {
    var baseShowWidgetLinkInfo = $.fn.showWidgetLinkInfo;
    $.fn.showWidgetLinkBlocked = function (infoText) {
        if (typeof baseShowWidgetLinkInfo === "function") {
            baseShowWidgetLinkInfo.call(this, infoText);
        }
        return this.each(function () {
            var $el = $(this);
            $el.addClass("btn-inactive pe-none");
            if (this.style && this.style.setProperty) {
                this.style.setProperty(
                    "background-color",
                    "#dddddd",
                    "important"
                );
                this.style.setProperty("color", "#FFFFFF", "important");
                this.style.setProperty(
                    "border",
                    "2px solid #dddddd",
                    "important"
                );
            } else {
                $el.css({
                    "background-color": "#dddddd",
                    color: "#FFFFFF",
                    border: "2px solid #dddddd"
                });
            }
            $el.on("click", function (event) {
                event.preventDefault();
                event.stopImmediatePropagation();
                return false;
            });
        });
    };
})(jQuery);
